var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-admin-sector-color",style:({ backgroundColor: _vm.actualColor })})}
var staticRenderFns = []

export { render, staticRenderFns }